import type { ReactNode } from "react";

import styles from "./table.module.css";

/**
 * One labelled row of a dialog on the Bots page — the mockup's `.fieldRow`,
 * on a modal's label column rather than a config page's.
 *
 * The three dialogs that use it (the roster row editor, the guild template
 * editor and «Create guilds») each wrote their own copy of this eight-line
 * component, and the two stylesheets behind them had drifted to two label
 * widths, so the twin dialogs did not line up. One component on one rule.
 *
 * Two kinds of sub-label, because the three dialogs need both and they are not
 * the same thing: `api` names the config path the boxes below write to and is
 * printed in mono, `hint` is a sentence about what the operator is choosing.
 */
export function DialogRow({
  label,
  api,
  hint,
  children,
}: {
  label: string;
  api?: string;
  hint?: string;
  children: ReactNode;
}) {
  return (
    <div className={styles.formRow}>
      <div className={styles.formLabel}>
        {label}
        {api && <div className={styles.formApi}>{api}</div>}
        {hint && <div className={styles.helper}>{hint}</div>}
      </div>
      <div>{children}</div>
    </div>
  );
}
